import { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DBRequest, useConfig } from '../../../api/api';
import { tokens } from '../../../global/theme/tokens';
import ExoAvatar from '../../../components/exo/ExoAvatar';

const EmployeeFilter = ({ value = [], onChange }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!config) return;
    DBRequest({
      config,
      path: 'users',
      onResponse: (res) => setUsers(res.data || []),
    });
  }, [config]);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const handleDelete = (userId) => {
    onChange(value.filter((id) => id !== userId));
  };

  const getUserById = (id) => users.find((u) => u.id === id);

  return (
    <Select
      multiple
      value={value}
      onChange={handleChange}
      displayEmpty
      size="small"
      sx={{
        minWidth: 200,
        maxWidth: 400,
        bgcolor: 'transparent',
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${colors.selected}50`,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: colors.info,
        },
        '& .MuiSelect-select': {
          py: '4px',
        },
      }}
      renderValue={(selected) => {
        if (selected.length === 0) {
          return (
            <Typography fontSize="13px" sx={{ opacity: 0.6 }}>
              {t('All Employees')}
            </Typography>
          );
        }
        return (
          <Box className="flex flex-wrap gap-1">
            {selected.map((id) => {
              const user = getUserById(id);
              if (!user) return null;
              return (
                <Chip
                  key={id}
                  size="small"
                  avatar={
                    <ExoAvatar
                      picture={user.picture?.temporaryUrl}
                      name={`${user.firstName} ${user.lastName}`}
                      size="20"
                    />
                  }
                  label={`${user.firstName} ${user.lastName}`}
                  onDelete={() => handleDelete(id)}
                  onMouseDown={(e) => e.stopPropagation()}
                  sx={{ height: 24, fontSize: '12px' }}
                />
              );
            })}
          </Box>
        );
      }}
    >
      {users.map((user) => (
        <MenuItem key={user.id} value={user.id}>
          <Box className="flex items-center gap-2">
            <ExoAvatar
              picture={user.picture?.temporaryUrl}
              name={`${user.firstName} ${user.lastName}`}
              size="24"
            />
            <Typography fontSize="13px">
              {user.firstName} {user.lastName}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default EmployeeFilter;
